
import React, { useEffect } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import Solutions from './components/Solutions';
import Testimonials from './components/Testimonials';
import CTA from './components/CTA';
import Footer from '../home/components/Footer';

const AutomMatePage: React.FC = () => {
  useEffect(() => {
    // Update page title and meta description for AutomMate page
    document.title = 'AutomMate Business Process Automation | RPA Solutions by WOTECH';
    
    // Add meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'AutomMate business process automation and RPA solutions. Streamline workflows, eliminate manual tasks, and boost productivity with WOTECH\'s automation expertise.');
    }

    // Add structured data for AutomMate product page
    const structuredData = {
      "@context": "https://schema.org",
      "@type": "Product",
      "name": "AutomMate Business Process Automation",
      "description": "Comprehensive business process automation and RPA platform for enterprise workflow optimization",
      "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/autommate`,
      "brand": {
        "@type": "Brand",
        "name": "AutomMate"
      },
      "provider": {
        "@type": "Organization",
        "name": "WOTECH"
      },
      "category": "Business Process Automation Software",
      "breadcrumb": {
        "@type": "BreadcrumbList",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "Home",
            "item": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}`
          },
          {
            "@type": "ListItem",
            "position": 2,
            "name": "Products",
            "item": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/products`
          },
          {
            "@type": "ListItem",
            "position": 3,
            "name": "AutomMate",
            "item": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/autommate`
          }
        ]
      }
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(structuredData);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <Hero />
        <Features />
        <Solutions />
        <Testimonials />
        <CTA />
      </main>
      <Footer />
    </div>
  );
};

export default AutomMatePage;
